import { render, staticRenderFns } from "./AdvanceDetail.vue?vue&type=template&id=0956d066&scoped=true"
import script from "./AdvanceDetail.vue?vue&type=script&lang=js"
export * from "./AdvanceDetail.vue?vue&type=script&lang=js"
import style0 from "./AdvanceDetail.vue?vue&type=style&index=0&id=0956d066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956d066",
  null
  
)

export default component.exports